// Libraries
import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';

// Subcomponents
import baseURL from './baseURL';

/** Create an Axios Client with defaults **/
let client: AxiosInstance;

export const initializeClient = function () {
  client = axios.create({
    baseURL: baseURL  + 'v1/',
    headers: {'Authorization': 'Bearer ' + localStorage.getItem('token')}
  });
};

initializeClient();

/** Request Wrapper with default success/error actions **/
const request = function (options: AxiosRequestConfig<any>) {
  const onSuccess = function (response: any) {
    return response;
  };

  const onError = function (
    error: { config: any; response: { status: number; data: any; headers: any; }; message: any; }
  ) {
    console.error('Request Failed: Config Sent:', error.config);

    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);

      if(error.response.status === 500){
        error.response.data = 'Server error';
      }
      if(!error.response.data.error) {
        error.response.data.error = error.response.data.message ?? '-';
      }
    } else {
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
